import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f0f50300"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "recipes" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { class: "panels" }

import SearchFilter from '../components/SearchFilter.vue';
import RecipePanel from '../components/RecipePanel.vue';
import { computed, watch, ref } from 'vue';
import { useStore } from 'vuex';
import { onBeforeRouteLeave, useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'RecipeListView',
  setup(__props) {

const store = useStore()

const route = useRoute()

let tagName = ref('')

if (route.params.tagSlug) {
  setTag()
}

const recipeList = computed(() => store.getters.getFilteredRecipes)

watch(() => route.params.tagSlug, setTag)

onBeforeRouteLeave(() => {
    store.commit('setTagFilter', []);
})

function setTag() {
  store.commit('setTagFilter', [route.params.tagSlug]);
  const tag = computed(() => store.getters.getTagFromSlug(route.params.tagSlug))
  tagName.value = tag.value.name
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_unref(route).params.tagSlug)
      ? (_openBlock(), _createElementBlock("h2", _hoisted_2, "Kategorie: " + _toDisplayString(_unref(tagName)), 1))
      : _createCommentVNode("", true),
    _createVNode(SearchFilter),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(recipeList), (item) => {
        return (_openBlock(), _createBlock(RecipePanel, {
          key: item.slug,
          recipe: item
        }, null, 8, ["recipe"]))
      }), 128))
    ])
  ]))
}
}

})